import { InsertOp } from './ops';

/**
 * Tests if the passed value is an insert operation.
 * @param val The value to check.
 */
export default (val: unknown): val is InsertOp =>
  val && typeof (val as any).insert === 'string';
